export class DateUtils {

	/**
	 * From a String or an Object Date get the Date, Month and Year
	 */
	public static getYearMonthDate(dateInstance: Date | string): { day: string, month: string, year: string } {
		const newDate: any = {
			day: '',
			month: '',
			year: ''
		};
		const date = new Date(dateInstance);
		newDate.day = date.getDate();
		newDate.month = date.getMonth() + 1;
		newDate.year = date.getFullYear();

		return newDate;
	}

	/**
	 * format a date to send in UTC for API
	 * @param date 
	 * @param isEnd 
	 * @returns 
	 */
	public static formatDateForApi(date: Date, isEnd: boolean = false): string {
		const d = new Date(date);
		if (isEnd) {
			d.setHours(23, 59, 59, 999);
		} else {
			d.setHours(0, 0, 0, 0);
		}
		return d.toISOString().split('.')[0];
	}

	/**
	 * convert today date to a range date
	 * @param daysAgo 
	 * @returns 
	 */

	public static getDateRangeFromToday(daysAgo: number): Date[] {
		const today = new Date();
		const end = new Date(today);
		end.setHours(23, 59, 59, 999);

		const start = new Date(today);
		start.setDate(today.getDate() - daysAgo);
		start.setHours(0, 0, 0, 0);

		return [start, end];
	}
}
